import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './features/auth/AuthProvider';
import { listenForInstallPrompt } from './features/install/installPrompt';
// A sorrend számít: az i18n előbb álljon fel, mint az első komponens.
import './i18n';
// A betű a csomagban utazik, nem CDN-ről: telepítve, gyenge térerőn is ez látszik (#57).
import '@fontsource-variable/figtree';
import './styles/tokens.css';
import './styles/app.css';

// A RENDER ELŐTT: a Chrome a telepítés eseményét gyakran még azelőtt elsüti,
// hogy a React felállna — egy komponensben felcsatolt figyelő lekésné.
listenForInstallPrompt();

const root = document.getElementById('root');
if (!root) {
  throw new Error('Hiányzik a #root elem az index.html-ből.');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
